<template>
  <div class="boxbgcolor p_and_e-qrcode">
    <div class="left content-left">
      <AreaTree v-on:handleTreeClick="handleTreeClick" :moduleName="moduleName"></AreaTree>
    </div>
    <div class="right content-right">
      <!--左侧上方搜索框-->
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float" @submit.prevent>
          <!-- <div class="form-group">
						<label for="">优免规则:</label>
						<input  v-model="search.plateNumber" class="form-control"  type="text" placeholder="" size="12"/>	
          </div>-->
          <div class="form-group">
            <label for>优免规则:</label>
            <el-select
              v-model="search.discountsRule"
              @focus="getRule()"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in allDiscountRulesData"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <button @click="searchList" type="button" class="btn btn-primary" id="search_btn">查询</button>
            </span>
            <span class="add_btn">
              <button type="button" class="btn btn-default" @click="addOrEdit()">添加</button>
            </span>
            <!--<button @click="clearSearch" type="button" class="btn btn-default">清空</button>-->

            <!-- <span class="refresh_btn"><Refresh @tableList="this.tableList"></Refresh></span> -->
          </div>
        </form>
      </div>
      <div class="list-right">
        <el-table
          border
          height="100%"
          :data="tableListData"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
        >
          <!-- <el-table-column  show-overflow-tooltip
					label="商家名称"
					prop=""
					>
          </el-table-column>-->
          <el-table-column show-overflow-tooltip label="优免规则" prop="discountsRule">
            <template
              slot-scope="scope"
            >{{scope.row.discountsRule?JSON.parse(scope.row.discountsRule).name:''}}</template>
          </el-table-column>
          <!-- <el-table-column  show-overflow-tooltip
					label="优免金额"
					prop="subtractMoney"
					>
					</el-table-column>
					<el-table-column  show-overflow-tooltip
					label="优免时间"
					prop="subtractTime"
					>
          </el-table-column>-->
          <el-table-column show-overflow-tooltip label="优免值" prop="value"></el-table-column>
          <el-table-column show-overflow-tooltip label="可使用次数/已使用次数" prop="usableAmount"></el-table-column>
          <el-table-column show-overflow-tooltip label="开始时间" prop="beginDate"></el-table-column>
          <el-table-column show-overflow-tooltip label="结束时间" prop="endDate"></el-table-column>
          <el-table-column show-overflow-tooltip label="操作人账号" prop="updName"></el-table-column>
          <el-table-column show-overflow-tooltip label="操作" width="250px">
            <template slot-scope="scope">
              <button class="edit operate-button" type="button" @click="addOrEdit(scope.row.id)">修改</button>
              <button class="delete operate-button" @click="del(scope.row.id)" type="button">删除</button>
              <button
                class="operate-button"
                @click="examineQrCode(scope.row.id,scope.row.parkingId)"
                type="button"
              >查看二维码</button>
              <button
                class="operate-button"
                @click="codeDownload(scope.row.id,JSON.parse(scope.row.discountsRule).name,scope.row.parkingId)"
                type="button"
              >下载二维码</button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <Page v-on:pagination="receivePaginationData" v-bind:pageObj="pageObj"></Page>
    <!--新增或修改优免二维码-->
    <el-dialog
      title="新增或修改优免二维码"
      :visible.sync="addOrEditdialogFormVisible"
      :lock-scroll="false"
      :close-on-click-modal="false"
      width="40%"
      @close="resetForm"
    >
      <el-form label-width="100px" :rules="rules" :model="formData" ref="addOrEditCodeForm">
        <el-form-item label="优免规则" prop="discountId">
          <el-select v-model="formData.discountId" placeholder="请选择">
            <el-option
              v-for="item in allDiscountRulesData"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="showDiscountValue" label="优免值" prop="value">
          <el-input v-model="formData.value">
            <template slot="append">
              <span v-if="showDiscountTime">分钟</span>
              <span v-if="showDiscountMoney">元</span>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="可使用次数" prop="usableAmount">
          <el-input v-model="formData.usableAmount">
            <template slot="append">*0表示不限次数</template>
          </el-input>
        </el-form-item>
        <el-form-item label="开始时间" prop="beginDate">
          <el-date-picker
            clearable
            value-format="yyyy-MM-dd HH:mm:SS"
            v-model="formData.beginDate"
            type="date"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="endDate">
          <el-date-picker
            clearable
            value-format="yyyy-MM-dd HH:mm:SS"
            v-model="formData.endDate"
            type="date"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addOrEditTrue">确定</el-button>
        <el-button @click="addOrEditdialogFormVisible = false">取消</el-button>
      </span>
    </el-dialog>
    <!--查看或下载二维码-->
    <el-dialog title="下载二维码" :visible.sync="codeDialogVisible" :lock-scroll="false">
      <table class="table" v-if="showQrcodeDownload">
        <thead>
          <tr>
            <td>二维码边长(cm)</td>
            <td>建议扫描距离(米)</td>
            <td>下载链接</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>8cm</td>
            <td>0.5m</td>
            <td @click="downloadQrcode(258,258)">
              <button class="code-download">下载</button>
            </td>
          </tr>
          <tr>
            <td>15cm</td>
            <td>1m</td>
            <td @click="downloadQrcode(430,430)">
              <button class="code-download">下载</button>
            </td>
          </tr>
        </tbody>
      </table>
      <div id="qrcode" v-show="showQrcode"></div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

import {
  getQrCodeList,
  getOneQrCode,
  getDiscountRulesByUserShop,
  addDiscountQrCode,
  editDiscountQrCode,
} from "@/api/url";

import Page from "../../commons/parking/commons/page.vue";

import AreaTree from "../../commons/parking/commons/areaTree.vue";

import Refresh from "../../commons/parking/commons/refresh.vue";

import QRCode from "qrcodejs2"; // 引入qrcode

export default {
  data() {
    //校验开始时间
    let validBeginDate = (rule, value, callback) => {
      let bDateVal = value;
      let eDateVal = this.formData.endDate;
      if (eDateVal) {
        var bdate = new Date(Date.parse(bDateVal.replace(/-/g, "/")));
        bdate = bdate.getTime();
        var edate = new Date(Date.parse(eDateVal.replace(/-/g, "/")));
        edate = edate.getTime();
        if (bdate - edate > 0) {
          callback(new Error("开始时间大于结束时间"));
        } else {
          callback();
        }
      }
    };
    //校验结束时间
    let validEndDate = (rule, value, callback) => {
      let eDateVal = value;
      let bDateVal = this.formData.beginDate;
      if (bDateVal) {
        var bdate = new Date(Date.parse(bDateVal.replace(/-/g, "/")));
        bdate = bdate.getTime();
        var edate = new Date(Date.parse(eDateVal.replace(/-/g, "/")));
        edate = edate.getTime();
        if (bdate - edate > 0) {
          callback(new Error("开始时间大于结束时间"));
        } else {
          callback();
        }
      }
    };
    return {
      treeData: {
        shopId: "",
        parkingId: "",
      },
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      moduleName: "shops",
      formData: {
        id: "",
        discountId: "",
        beginDate: "",
        endDate: "",
        // subtractMoney:'',
        // subtractTime:'',
        value: "",
        usableAmount: "",
      },
      showQrcode: false,
      showQrcodeDownload: false,
      showDiscountValue: false,
      showDiscountMoney: false,
      showDiscountTime: false,
      allDiscountRulesData: [],
      addOrEditdialogFormVisible: false,
      codeDialogVisible: false,
      dialogRechargeVisible: false,
      allFbType: [],
      search: {
        pageNumber: 1,
        pageSize: 10,
        discountsRule: "",
        // carType:"",
        // plateType:"",
        // openMethod:"",
        // beginDate:'',
        // endDate:''
      },
      tableListData: [],
      allCarTypes: null,
      allPlateTypes: null,
      allOpenMethods: null,
      defaultProps: {
        children: "children",
        label: "label",
      },
      formLabelWidth: "100px",
      allImgUrl: [],
      imgUrl: "",
      codeDownloadData: {
        qrCodeId: "",
        qrCodeName: "",
        parkingId: "",
      },
      rules: {
        discountId: [
          {
            required: true,
            message: "请选择优免规则",
            trigger: ["blur", "change"],
          },
        ],
        value: [{ required: true, message: "请填写优免值", trigger: "blur" }],
        usableAmount: [
          { required: true, message: "请填写优免次数", trigger: "blur" },
        ],
        beginDate: [
          { required: true, message: "请选择开始时间", trigger: "blur,change" },
          // {validator:validBeginDate,trigger: "change"}
        ],
        endDate: [
          { required: true, message: "请选择结束时间", trigger: "blur,change" },
          //  {validator:validEndDate,trigger: "change"}
        ],
      },
      pageObj:{}
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      if (!this.treeData.shopId) {
        this.$message({
          type: "warning",
          message: "请选择商户",
        });
        return;
      }
      this.tableList(this.search.pageNumber);
    },
    //点击树的节点展示相应数据
    handleTreeClick: function (node, data) {
      this.search.discountsRule = "";
      if (node.type === "shops") {
        this.treeData.shopId = node.id;
        this.treeData.parkingId = node.parentId;
        this.search.pageNumber = 1;
        this.tableList(this.search.pageNumber);
        this.allDiscountRules(this.treeData.shopId);
      } else {
        this.treeData.id = "";
        this.tableListData = [];
        //  this.$message({
        // 	message: '请选择商户！',
        // 	type: 'warning'
        // 	});
      }
    },
    tableList: function (curPage) {
      var _this = this;
      this.$get(getQrCodeList(), {
        shopsId: this.treeData.shopId,
        discountsRule: this.search.discountsRule,
        // beginDate:this.search.beginDate==''?'':JSON.stringify(this.search.beginDate),
        // endDate:this.search.endDate==''?'':JSON.stringify(this.search.endDate),
        limit: this.search.pageSize,
        page: curPage,
      }).then((data) => {
        if (data.status != 200) return;
        //翻页
        var rows = data.data.rows;
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        _this.pageObj={...pageObj}
        // _this.getPage(pageObj);
        _this.tableListData = data.data.rows;
      });
    },
    searchList: function () {
      if (!this.treeData.shopId) {
        this.$message({
          type: "warning",
          message: "请选择商户",
        });
        return;
      }
      this.search.pageNumber = "1";
      this.tableList(this.search.pageNumber);
    },
    clearSearch: function () {
      this.search.pageNumber = "1";
      this.search.fbMsg = "";
    },
    addOrEdit(id) {
      var _this = this;
      if (id) {
        this.addOrEditdialogFormVisible = true;
        this.$postRequest(getOneQrCode(), {
          id: id,
        }).then((data) => {
          if (data.status != 200) return;
          var temp = data.data;
          this.formData.id = temp.id;
          this.formData.discountId = temp.discountsRule;
          this.formData.beginDate = temp.beginDate;
          this.formData.endDate = temp.endDate;
          this.formData.value = temp.value;
          // if(temp.subtractMoney){
          // 	this.formData.subtractMoney=temp.subtractMoney
          // 	this.showDiscountMoney=true;
          // 	this.showDiscountTime=false;
          // }
          // if(temp.subtractTime){
          // 	this.formData.subtractTime=temp.subtractTime
          // 	this.showDiscountMoney=false;
          // 	this.showDiscountTime=true;
          // }
          this.formData.usableAmount = temp.usableAmount;
        });
      } else {
        if (this.treeData.shopId) {
          this.addOrEditdialogFormVisible = true;
          this.formData.id = "";
          this.formData.discountId = "";
          this.formData.beginDate = "";
          this.formData.endDate = "";
          // this.formData.subtractMoney=''
          // this.formData.subtractTime=''
          this.formData.value = "";
          this.formData.usableAmount = "";
        } else {
          this.addOrEditdialogFormVisible = false;
          this.$message({
            message: "请选择商户!",
            type: "warning",
          });
        }
      }
    },
    addOrEditTrue() {
      var _this = this;
      this.$refs.addOrEditCodeForm.validate(function (valid) {
        if (valid) {
          _this.addOrEditdialogFormVisible = false;
          if (_this.formData.id) {
            _this
              .$putRequest(addDiscountQrCode() + "/" + _this.formData.id, {
                id: _this.formData.id,
                beginDate: _this.formData.beginDate,
                endDate: _this.formData.endDate,
                usableAmount: _this.formData.usableAmount,
                value: _this.formData.value,
                shopsId: _this.treeData.shopId,
                parkingId: _this.treeData.parkingId,
                discountsRule: _this.formData.discountId,
              })
              .then((data) => {
                if (data.status != 200) {
                  _this.$notify({
                    type: "warning",
                    title: "失败",
                    message: data.message,
                  });
                  return;
                }
                _this.$notify({
                  type: "success",
                  title: "成功",
                  message: "修改成功",
                });
                _this.tableList(_this.pageObj.curIndex);
              });
          } else {
            _this
              .$postRequest(addDiscountQrCode(), {
                beginDate: _this.formData.beginDate,
                endDate: _this.formData.endDate,
                // subtractMoney:this.formData.subtractMoney,
                // subtractTime:this.formData.subtractTime,
                usableAmount: _this.formData.usableAmount,
                value: _this.formData.value,
                shopsId: _this.treeData.shopId,
                parkingId: _this.treeData.parkingId,
                discountsRule: _this.formData.discountId,
              })
              .then((data) => {
                if (data.status != 200) {
                  _thisthis.$notify({
                    type: "warning",
                    title: "失败",
                    message: data.message,
                  });
                  return;
                }
                _this.$notify({
                  type: "success",
                  title: "成功",
                  message: "添加成功",
                });
                _this.search.pageNumber = 1;
                _this.tableList(_this.search.pageNumber);
              });
          }
        } else {
        }
      });
    },

    del: function (id) {
      var _this = this;

      var index = _this.$layer.confirm(
        "您确定删除？",
        {
          btn: ["确定", "取消"],
          shade: false,
          type: 0,
        },
        function () {
          _this.$layer.close(index);

          _this
            .$deleteRequest(addDiscountQrCode() + "/" + id + "?id=" + id)
            .then((data) => {
              if (data.status != 200)
                return _this.$layer.msg("删除失败", { time: 1 });
              _this.$notify({
                type: "success",
                title: "成功",
                message: "删除成功！",
              });
              _this.tableList(_this.pageObj.curIndex);
            });
        }
      );
    },
    examineQrCode(id, parkingId) {
      var _this = this;

      this.codeDialogVisible = true;
      this.showQrcode = true;
      this.showQrcodeDownload = false;

      setTimeout(function () {
        document.getElementById("qrcode").innerHTML = "";
        _this.qrcode(id, parkingId, 258, 258);
      }, 1);
    },

    codeDownload(id, name, parkingId) {
      this.showQrcode = false;
      this.showQrcodeDownload = true;
      this.codeDialogVisible = true;
      this.codeDownloadData.qrCodeId = id;
      this.codeDownloadData.qrCodeName = name;
      this.codeDownloadData.parkingId = parkingId;
    },
    qrcode(id, parkingId, w, h) {
      // console.log('id:'+id)
      let qrcode = new QRCode("qrcode", {
        width: w,
        height: h,
        colorDark: "#000",
        colorLight: "#fff",
      });
      qrcode.clear(); //清除二维码
      // qrcode.makeCode(
      //   `${this.$codeUrl}/pay/sweepCodePayment/onSite?parkingId=${id}`
      // ); //生成另一个新的二维码
       qrcode.makeCode(`${this.$codeUrl}/pay/discount?parkingId=${parkingId}&qrCodeId=${id}`) //生成另一个新的二维码
    },
    downloadQrcode(w, h) {
      document.getElementById("qrcode").innerHTML = "";
      var qrCodeId = this.codeDownloadData.qrCodeId;
      var parkingId = this.codeDownloadData.parkingId;
      var name = this.codeDownloadData.qrCodeName;
      this.qrcode(qrCodeId, parkingId, w, h);
      setTimeout(function () {
        var qrcode = document.getElementById("qrcode");
        var img = qrcode.getElementsByTagName("img")[0];
        var link = document.createElement("a");
        var url = img.getAttribute("src");
        link.setAttribute("href", url);
        link.setAttribute("download", `${name}(${w}).png`);
        link.dispatchEvent(
          new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            view: window,
          })
        );
      }, 1);
    },
    allDiscountRules(id) {
      this.allDiscountRulesData = [];
      this.$get(getDiscountRulesByUserShop(), {
        shopsId: this.treeData.shopId,
        limit: "0",
      }).then((data) => {
        // if(data.status!=200)return;
        var temp = data.data.rows;
        for (let item of temp) {
          let t = {
            label: "",
            value: "",
            discountType: "",
          };
          t.label = item.name;
          t.value = item.id;
          t.discountType = item.discountsType;
          this.allDiscountRulesData.push(t);
        }
      });
    },
    getRule() {
      if (!this.treeData.shopId) {
        this.$message({
          type: "warning",
          message: "请选择车场",
        });
        return;
      }
    },
    resetForm() {
      this.$refs["addOrEditCodeForm"].resetFields();
    },
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
    }),
    handleDiscount() {
      return this.formData.discountId;
    },
  },
  components: {
    Page,
    AreaTree,
    Refresh,
  },
  mounted: function () {
    // this.allDiscountRules();
    // this.tableList(this.search.pageNumber);
  },
  watch: {
    handleDiscount: function (newVal, oldVal) {
      // console.log(newVal)
      //需优化 discountType
      for (let item of this.allDiscountRulesData) {
        var temp = item;
        if (temp.value === newVal) {
          // console.log(temp)
          if (temp.discountType == "减免金额") {
            this.showDiscountValue = true;
            this.showDiscountMoney = true;
            this.showDiscountTime = false;
          } else if (temp.discountType == "减免时间") {
            this.showDiscountValue = true;
            this.showDiscountTime = true;
            this.showDiscountMoney = false;
          } else {
            this.showDiscountValue = false;
          }
        }
      }
    },
  },
};
</script>

<style scoped>
.sameLine .el-form-item__content .el-input {
  display: inline-block;
  width: 70%;
}
.tip {
  color: red;
}
#qrcode {
  display: flex;
  justify-content: center;
}
</style>
<style>
.p_and_e-qrcode .el-select,
.p_and_e-qrcode .el-date-editor {
  /* width:100%!important;
	max-width:100%!important; */
}
.p_and_e-qrcode .el-input-group__append {
  background: none !important;
  color: red;
  border: none !important;
  padding-left: 10px !important;
  text-align: left !important;
}
</style>